export type AccountMenuLink = { href: string; label: string };

const SOCIAL_ACCOUNT_LINKS: AccountMenuLink[] = [
  { href: '/settings/account/', label: 'Settings' },
  { href: '/settings/invite/', label: 'Invite members' },
  { href: '/settings/notifications/', label: 'Notifications' },
];

const ITSM_ACCOUNT_LINKS: AccountMenuLink[] = [{ href: '/settings/account/', label: 'Settings' }];

/** Ops ITSM is a standalone app — no Communio Social profile, blog, or invite chrome. */
export function accountMenuLinks(ops: boolean): AccountMenuLink[] {
  return ops ? ITSM_ACCOUNT_LINKS : SOCIAL_ACCOUNT_LINKS;
}

export { isOpsItsmBuild } from '@/platform/servicedesk/isOpsItsmBuild';
